<template>
    <div class="">
        <group-page-header title="About Group">
            <span slot="additionalButtons">
                <toggle-edit-mode-button
                        v-if="viewer_state.is_admin"
                        v-model="editMode"
                ></toggle-edit-mode-button>
            </span>
        </group-page-header>
        <div class="alert alert-info margin-15-bottom margin-15-top" v-if="group.is_private&&viewer_state.is_admin">
            This page is accessible to public. Only put information on the Group ‘About page’ that you are happy to
            share
            with everyone.
        </div>
        <story-list
                :story-resource="GroupStoryResource"
                :target-id="targetId"
                :edit-mode="editMode"
                :allow-add-content="viewer_state.is_admin"
                add-button-text="Add to About Page"
        >
            <div class="alert alert-info" slot="empty">There has been nothing added to this Group's story yet</div>
        </story-list>
    </div>
</template>

<script>
    import Vue from 'vue';
    import StoryList from "shared/story/StoryList";
    import LikeStoryResourceFactory from "shared/story/resource_factory";
    import {mapGetters} from "vuex";
    import GroupPageHeader from "./common/GroupPageHeader";
    import ToggleEditModeButton from "./common/ToggleEditModeButton";

    export default {
        name: "GroupPageStory",
        components: {ToggleEditModeButton, GroupPageHeader, StoryList},
        data() {
            return {
                editMode: false,
            };
        },
        computed: {
            ...mapGetters('groupPage', {group: 'group', viewer_state: 'viewer_state'}),
            GroupStoryResource() {
                const $http = Vue.getAngularModule('$http');
                return LikeStoryResourceFactory('group_story')($http);
            },
            targetId() {
                return this.group.id;
            },

        }
    };
</script>

<style scoped lang="scss">
  @import "commonStyle";
</style>